export const blockIconsHardwareCastForEducation = (
	<span className='material-symbols-outlined'>cast_for_education</span>
);
